var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-arrow-bg"},[_c('i',{staticClass:"arrow top-left"}),_c('i',{staticClass:"arrow top-right"}),_c('i',{staticClass:"arrow bottom-left"}),_c('i',{staticClass:"arrow bottom-right"}),(_vm.showHeader)?_c('div',{staticClass:"v-arrow-header"},[_vm._t("header")],2):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }